import { FC } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAppSelector } from 'store/hooks'
import Header from './components/Breakout/Header'

interface IBreakoutLayoutProps {
  title?: string
  description?: string
}

const BreakoutLayout: FC<IBreakoutLayoutProps> = ({
  title = 'Add Blackout Periods',
  description = 'Use the calendar to add unavailable times to locations.'
}) => {
  const { token } = useAppSelector((state) => state.auth)
  let location = useLocation()

  if (!token) {
    const loginRoute = '/'
    return <Navigate to={loginRoute} state={{ from: location }} replace />
  }

  return (
    <div className="h-full">
      <Header title={title} description={description} />
      <Outlet />
    </div>
  )
}
export default BreakoutLayout
